class ProductLanguageViewController extends MUIViewController
{
    static newInstance() : ProductLanguageViewController { 
        let vc = new ProductLanguageViewController("product-languages-view");
        vc.initWithResource("layout/products/ProductLanguagesView.html");
        return vc;
    }    

    private closeButton:MUIButton = null;
    private saveButton:MUIButton = null;
    private translateButton:MUIButton = null;
    private tableView:UITableView = null;

    modalSize = new MIOSize(400, 400); 

    get preferredContentSize(){
        return this.modalSize
    }

    viewDidLoad(){
        super.viewDidLoad();

        this.closeButton = MUIOutlet(this, "close-btn", "MUIButton");
        this.closeButton.setAction(this, function(){
            DBHelper.saveMainContext();
            this.dismissViewController(true);
        });      

        this.saveButton = MUIOutlet(this, "save-btn", "MUIButton");
        this.saveButton.setAction(this, function(){
            DBHelper.saveMainContext();
        });

        this.translateButton = MUIOutlet(this, "translate-btn", "MUIButton");
        this.translateButton.setAction(this, this.translate );

        this.tableView = MUIOutlet(this, "table-view", "UITableView");        
        this.tableView.dataSource = this;
        this.tableView.delegate = this as any;

        this.tableView.reloadData();
    }

    viewDidAppear(animated:boolean){
        super.viewDidAppear(animated);
        this.updateUI();
    }

    private _object:MIOManagedObject = null;
    private _key:string = null;
    private _multiline:boolean = false;
    setItem(object:MIOManagedObject, key:string, multiline:boolean = false) {
        this._object = object;
        this._key = key;
        this._multiline = multiline;

        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false || this._object == null) return;

        this.fetchedResultsController = null;
        this.mapValues( this.fetchedResultsController.fetchedObjects as LocalizedValue[] );
        this.tableView.reloadData();
    }
    
    numberOfSections(tableView:UITableView){
        return 1;
    }
    
    numberOfRowsInSection(tableView:UITableView, section:number){
        return this._languages_values != null ? AppHelper.sharedInstance().aditionalLanguages.length : 0;
    }

    cellAtIndexPath(tableview:UITableView, indexPath:MIOIndexPath){
        let identifier = this._multiline ? "LanguageAreaCell" : "LanguageTextFieldCell";
        let cell = tableview.dequeueReusableCellWithIdentifier(identifier) as ProductLanguageCell;

        let lang = AppHelper.sharedInstance().aditionalLanguages[indexPath.row];
        cell.delegate = this;
        cell.language = lang;
        cell.setItem( this._languages_values[lang], this._object, this._key, lang );

        return cell;
    }

    protected _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value) {
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
    
        this._fetchedResultsController = value;
    }
    
    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;

        let ad:AppDelegate = MUIWebApplication.sharedInstance().delegate;
        
        let entity_name = this._object.objectID.entity.name;
        let identifier = this._object.valueForKey("identifier") as string;
        let pf = "entityIdentifier == '" + identifier + "' AND entityTypeName == '" + entity_name + "' AND key == '" + this._key + "'";
        let fetchRequest = DBHelper.listFetchRequestWithEntityName( "LocalizedValue", null, pf );
       
        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest( fetchRequest, ad.managedObjectContext, null );
        fetchedResultsController.delegate = this;
        fetchedResultsController.performFetch();
    
        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;
    }
    
    private _languages_values = null;

    controllerDidChangeContent(controller:MIOFetchedResultsController) {
        
        this.mapValues( controller.fetchedObjects as LocalizedValue[] );
        this.tableView.reloadData();
    }

    private mapValues( values:LocalizedValue[] ){
        this._languages_values = {};
        for (let v of values){
            this._languages_values[v.language] = v;
        }
    }

    localizedValueCellDidInsert( cell:ProductLanguageCell, value:string, language:string ) {
        this.updateLocalizeValue( value, language );
    }

    private translate() {
        let webService = MUIWebApplication.sharedInstance().delegate.webService;
        webService.translate( this._object.valueForKey(this._key) as string, AppHelper.sharedInstance().aditionalLanguages, (translations:any) => {
            for (let lang in translations) {
                this.updateLocalizeValue( translations[lang], lang );
            }
            this.tableView.reloadData();
        } );
    }

    private updateLocalizeValue( value:string, language:string ) {        
        let localize_value = this._languages_values[language];

        if (value == null && localize_value != null) {
            DBHelper.deleteObjectFromMainContext(localize_value, false);
            delete this._languages_values[ language ];
            return;
        }

        if (localize_value == null){
            const ctx = (MUIWebApplication.sharedInstance().delegate as AppDelegate).managedObjectContext;
            localize_value = MIOEntityDescription.insertNewObjectForEntityForName("LocalizedValue", ctx) as LocalizedValue;
            localize_value.language = language;
            localize_value.key = this._key;
            localize_value.entityTypeName = this._object.objectID.entity.name;
            localize_value.entityIdentifier = this._object.valueForKey("identifier");            
            this._languages_values[ language ] = localize_value;
        }
        
        localize_value.value = value;        
    }

}